import { Button } from 'antd'
import { isVideo } from '../../../utilities'
import { MdOutlineOpenInNew } from 'react-icons/md'
import ReactPlayer from 'react-player'
import DrawerBox from '../../../components/common/DrawerBox'
import { isMobile } from 'react-device-detect'
import { AiOutlineClose, AiFillPushpin } from 'react-icons/ai'

function AdminAdView({ advData, open, setOpen, sendOutAd }) {
  const handleAdvClickOrView = (isClick, ev) => {
    if (ev) {
      ev.stopPropagation()
    }
    if (!advData || !advData.adId) {
      return
    }
    if (isClick && advData.sourceUrl) {
      document.activeElement.blur()
      window.open(advData.sourceUrl, '_blank')
    }
  }

  return (
    <DrawerBox placement={isMobile ? 'bottom' : 'right'} headerStyle={{ display: 'none' }} bodyStyle={{ padding: '24px' }} width='450px' visible={open} setVisible={setOpen} closable={true}>
      <div className='flex fd-row items-center jc-space-between mb-8'>
        <h3 className='font-size-20 font-bold-700 font-color-2'>View Section Adv</h3>
        <Button type='link' size='medium' danger ghost onClick={setOpen} className='flex fd-row items-center font-size-16'>
          <AiOutlineClose className='mr-4' />
          Close
        </Button>
      </div>
      <div className='mb-16 flex jc-space-between width-full'>
        <div type='primary' size='large' onClick={sendOutAd} className='button-gradient font-bold-600 flex-grow-1 jc-center flex items-center pt-6 pb-6 rounded-12 font-color-white cursor-pointer' style={{ border: 'none' }}>
          <AiFillPushpin className='mr-8' /> Push To All Users
        </div>
      </div>
      <div className='mb-14 mt-24'>
        <hr className='border-color-10' style={{ marginRight: '-24px', marginLeft: '-24px' }} />
      </div>
      {isVideo(advData.contentUrl) ? (
        <div>
          <Button
            type='primary'
            icon={<MdOutlineOpenInNew className='mr-8' />}
            size='small'
            className='flex items-center bg-white-80 font-color-1 border-white-80'
            onClick={(e) => handleAdvClickOrView(true, e)}
            style={{ float: 'right', marginBottom: '-80px', marginTop: '10px', marginRight: '10px', zIndex: '100' }}
          >
            Learn More
          </Button>
          <ReactPlayer playing={true} url={advData.contentUrl} config={{ file: { attributes: { controlsList: 'nodownload' } } }} width='100%' loop={true} playsinline={true} muted={true} controls={true} />
        </div>
      ) : (
        <img onClick={() => handleAdvClickOrView(true)} src={advData.contentUrl} width={'100%'} style={{ objectFit: 'contain' }} alt={advData.name} className='rounded-12' />
      )}
    </DrawerBox>
  )
}

export default AdminAdView
